import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import { useEffect, useState } from 'react';
import styles from './destacatDtyDestacat.module.scss';

const DestacatDtyDestacat = (props) => {
    const { item, testId, estil, tema, priorityImage, numColumnsRow, tag, marcatgeAudienciesClick } = props;
    const { id, titol, imatges, url } = item || props;

    let TagSeo = tag;

    const { redlAuxState = {} } = item || props;
    const { isRedlId, isRedlTipologia } = redlAuxState;
    const [hasRedlParams, setHasRedlParams] = useState(false);
    const route = { href: url };

    useEffect(() => {
        if (isRedlId || isRedlTipologia) {
            setHasRedlParams(true);
        }
    }, [isRedlId, isRedlTipologia]);

    const styleCos = clsx({
        [styles.cos]: true,
        [styles.hasRedlParams]: hasRedlParams
    });
    const styleWrapper = clsx({
        [styles.imatgeWrapper]: true,
        [styles[tema]]: !!tema
    });
    const stylesDestacat = clsx({
        [styles.destacatBasic]: true,
        [styles[estil]]: !!estil,
        [styles['col' + numColumnsRow]]: numColumnsRow > 0
    });

    return titol ? (
        <div key={`destacat-basic-${id}`} className={stylesDestacat} {...(testId && { 'data-testid': testId })} role='article'>
            <Enllac route={route} dataTestId='destacat-enllac' marcatgeAudienciesClick={marcatgeAudienciesClick}>
                <section className={styleCos}>
                    {imatges && (
                        <div className={styleWrapper} data-testid='destacat-content-imatge'>
                            <Imatge
                                imatges={imatges}
                                className={styles.imatge}
                                tipus='web_destacat'
                                numColumnsRow={numColumnsRow}
                                aria-hidden='true'
                                layout='fill'
                                objectFit='cover'
                                priority={priorityImage}
                                crop='1903'
                                data_testid='destacat-img'
                            />
                        </div>
                    )}
                    <TagSeo className={styles.titol} data-testid='destacat-titol'>
                        <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                    </TagSeo>
                </section>
            </Enllac>
        </div>
    ) : null;
};

DestacatDtyDestacat.defaultProps = {
    priorityImage: false,
    mostraComarca: false,
    numColumnsRow: 0,
    tag: 'h3'
};

export default DestacatDtyDestacat;
